import globalStore from '$$globalStore';
import app from '$$app';
import projectComponent from '../../Project';

function onTaskLinkDeleted(event) {
  const links = event.innerSettings.collaborationItems.filter(link => projectComponent.userHasProject(link.gantt_id));

  if (links.length) {
    globalStore.commit('tasksModel/removeLinks', { links, fromGantt: false }, { root: true });
  }

  app.trigger('onAfterCollaboration', {
    event: event.event,
    ids: event.data.id,
  });
}

export default onTaskLinkDeleted;
